module.exports = __webpack_public_path__ + "view/img/cadalou.dc4c0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cadalou.png
// module id = 3D+/
// module chunks = 13